import { render, staticRenderFns } from "./RecommendationItem.vue?vue&type=template&id=5f4f4868&"
import script from "./RecommendationItem.vue?vue&type=script&lang=js&"
export * from "./RecommendationItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports